// extracted by mini-css-extract-plugin
module.exports = {"vertical":"FormInputGroup_vertical__NLkvA","horizontal":"FormInputGroup_horizontal__1cj6W"};